module.exports = __webpack_public_path__ + "img/ricelog_pinicon_022.a6df0ac4.png";